import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";


function Reviews() {
  const { rpdata } = useContext(GlobalDataContext);




  return (
    <BaseLayout PageName="Reviews">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="Reviews"
          Subheader="Reviews"
          bgimg={`${rpdata?.gallery?.[5]}`}
        />
      </div>
      <div className="w-[90%] md:w-4/5 mx-auto py-[100px]">
        <h1 className="text-center pb-4 text-white">
          {rpdata?.labels?.general?.titleReviews}
        </h1>
        


        {/* reviews de elfsight */}
        <review-widget widgetId="21383b21-d8d7-4e8d-a308-3828926f6027
"></review-widget>


      </div>
      
    </BaseLayout>
  );
}

export default Reviews;